<template>
  <generic-modal
    size="large"
    :title="$t('tibix configuration')"
    icon="settings"
    image="/images/icons/tibix.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    :on_finished="finished"
  >
    <div class="description">
      <div class="ui six item top attached tabular menu" ref="tabs">
        <a class="active item" data-tab="document_types"
          ><i class="id card icon"></i>{{ $t("document types") }}</a
        >
        <a class="item" data-tab="countries"
          ><i class="globe americas icon"></i> {{ $t("countries") }}</a
        >
        <a class="item" data-tab="deparments"
          ><i class="city icon"></i> {{ $t("departments") }}</a
        >
        <a class="item" data-tab="imigrations"
          ><i class="map marked alternate icon"></i> {{ $t("imigrations") }}</a
        >
        <a class="item" data-tab="incomes"
          ><i class="wallet icon"></i> {{ $t("incomes") }}</a
        >

        <a class="item" data-tab="banks"
          ><i class="piggy bank icon"></i> {{ $t("banks") }}</a
        >
      </div>
      <div
        class="ui bottom attached active tab segment"
        data-tab="document_types"
      >
        <document-types ref="document_types" />
      </div>
      <div class="ui bottom attached tab segment" data-tab="countries">
        <countries ref="countries" />
      </div>
      <div class="ui bottom attached tab segment" data-tab="deparments">
        <departments ref="departments" />
      </div>
      <div class="ui bottom attached tab segment" data-tab="imigrations">
        <imigrations ref="imigrations" />
      </div>
      <div class="ui bottom attached tab segment" data-tab="incomes">
        <incomes ref="incomes" />
      </div>
      <div class="ui bottom attached tab segment" data-tab="banks">
        <banks ref="banks" />
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api } from "@/utils";
import GenericModal from "@/components/GenericModal";
import DocumentTypes from "./DocumentTypes";
import Countries from "./Countries";
import Departments from "./Departments";
import Imigrations from "./Imigrations";
import Incomes from "./Incomes";
import Banks from "./Banks";

export default {
  name: "NvidiaBundleConfigurationModal",
  components: {
    "generic-modal": GenericModal,
    DocumentTypes,
    Countries,
    Departments,
    Imigrations,
    Incomes,
    Banks,
  },
  computed: {},
  data() {
    return {};
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    init() {
      let vm = this;
      local_api(vm, "post", "/tibix/configuration/do-get").then((conf) => {
        console.log;
        if (conf && conf.document_types) {
          vm.$refs.document_types.setList(conf.document_types);
        }
        if (conf && conf.countries) {
          vm.$refs.countries.setList(conf.countries);
        }
        if (conf && conf.departments) {
          vm.$refs.departments.setList(conf.departments);
        }
        if (conf && conf.imigration_types) {
          vm.$refs.imigrations.setList(conf.imigration_types);
        }
        if (conf && conf.incomes) {
          vm.$refs.incomes.setList(conf.incomes);
        }
        if (conf && conf.banks) {
          vm.$refs.banks.setList(conf.banks);
        }
      });
    },
    finished() {
      let vm = this;
      return new Promise(function (resolve, reject) {
        local_api(vm, "post", "/tibix/configuration/do-save", {
          s: {
            document_types: vm.$refs.document_types.getList(),
            countries: vm.$refs.countries.getList(),
            departments: vm.$refs.departments.getList(),
            imigration_types: vm.$refs.imigrations.getList(),
            incomes: vm.$refs.incomes.getList(),
            banks: vm.$refs.banks.getList(),
          },
        })
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  mounted() {
    this.init();
    let vm = this;

    window.jQuery(vm.$refs.tabs).find(".item").tab();
  },
};
</script>
